module.exports = __webpack_public_path__ + "img/wechatCode.154ea69b.png";